module.exports = __webpack_public_path__ + "img/c-bg-top.440188f1.png";